const SESSION = "session-";
export const sessionTitleBuilder = (sessionId) => {
    return SESSION + sessionId;
};
